import { render, staticRenderFns } from "./CowsListFilterComponent.vue?vue&type=template&id=641c3f04&scoped=true&"
import script from "./CowsListFilterComponent.vue?vue&type=script&lang=js&"
export * from "./CowsListFilterComponent.vue?vue&type=script&lang=js&"
import style0 from "./CowsListFilterComponent.vue?vue&type=style&index=0&id=641c3f04&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641c3f04",
  null
  
)

export default component.exports